export default function sumBy(arr, iteratee) {
	if (arr && iteratee) {
		if (Array.isArray(arr)) {
			if (iteratee.constructor === Function) {
				return arr.reduce((acc, element) => acc + iteratee(element), 0)
			} else {
				return arr.reduce((acc, element) => {
					return (acc +=
						element.constructor === Object ? element[iteratee] : element)
				}, 0)
			}
		}
	}
}
